import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { About } from '../components/About';
import { Location } from '../components/Location';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-cyber-black text-white selection:bg-cyber-pink selection:text-white" data-id="element-172">
      {/* Global Scanline Overlay */}
      <div className="scanlines" data-id="element-173" />

      <Navbar data-id="element-174" />

      <main data-id="element-175">
        <Hero data-id="element-176" />
        <Services data-id="element-177" />
        <About data-id="element-178" />
        <Location data-id="element-179" />
      </main>

      <Footer data-id="element-180" />
    </div>;
}